import i18next from 'i18next'

export function extractBrandSetName(name: string | null | undefined, website: string) {
	if (name?.trim()) { return name.trim() }
	if (!website) { return i18next.t('editor:brandSet.unnamed') }
	try {
		const url = new URL(website.startsWith('http') ? website : `https://${website}`)
		return url.hostname.replace(/^www\./, '')
	} catch {
		return website
	}
}
